import React, { Component } from 'react';
import PropTypes from 'prop-types';
import posed, { PoseGroup } from 'react-pose';
import ReactPaginate from 'react-paginate';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { LinkContainer } from 'react-router-bootstrap';
import UserFilter from '../components/user/Filter';
import CouponCampaignFilter from '../components/couponCampaign/Filter';
import BackButton from '../controls/BackButton';

const ListContainer = posed.div({
  enter: { staggerChildren: 50 },
  exit: { staggerChildren: 20, staggerDirection: -1 },
});

const Item = posed.div({
  enter: { y: 0, opacity: 1 },
  exit: { y: 50, opacity: 0 },
});

export default class List extends Component {
  componentWillMount() {
    const {
      requestList, pageIndex, pageSize, sortBy, sortDescending, filters,
    } = this.props;

    requestList(pageIndex, pageSize, sortBy, sortDescending, filters);

    // this.timer = setInterval(() => this.reload(), 180000);
  }

  componentWillUnmount() {
    // clearInterval(this.timer);
  }

  handlePageChange = (data) => {
    const {
      requestList, pageSize, sortBy, sortDescending, pageIndex, filters,
    } = this.props;
    const { selected } = data;

    if (pageIndex !== selected) requestList(selected, pageSize, sortBy, sortDescending, filters);
  };

  handleSortChange = (sortBy, sortDescending) => {
    const {
      requestList, pageIndex, pageSize, filters,
    } = this.props;

    requestList(pageIndex, pageSize, sortBy, sortDescending, filters);
  };

  handleFilterChange = (field, operator, value) => {
    const {
      requestList, pageSize, sortBy, sortDescending, filters,
    } = this.props;

    const filter = filters.find(f => f.field === field);

    if (filter) {
      if ((filter.value === value && filter.operator === operator) || value == null) {
        const index = filters.indexOf(filter);
        if (index > -1) {
          filters.splice(index, 1);
        }
      } else {
        filter.value = value;
        filter.operator = operator;
      }
    } else if (value != null) {
      filters.push({ field, operator, value });
    }

    requestList(0, pageSize, sortBy, sortDescending, [...filters]);
  };

  handleFiltersChange = (filters) => {
    const {
      requestList, pageSize, sortBy, sortDescending,
    } = this.props;

    requestList(0, pageSize, sortBy, sortDescending, [...filters]);
  };

  reload() {
    const {
      requestList, pageIndex, pageSize, sortBy, sortDescending, filters,
    } = this.props;

    requestList(pageIndex, pageSize, sortBy, sortDescending, filters);
  }

  render() {
    const {
      children,
      title,
      totalPages,
      totalItems,
      tableColumns,
      tableData,
      newLink,
      sortBy,
      sortDescending,
      pageSize,
      pageIndex,
      preferTable,
      switchDisplayStyle,
      backButton,
    } = this.props;

    // fix relative height with filters
    let scrollerHeight = '';
    if (newLink === '/location/new' && window.innerHeight < 800) {
      scrollerHeight = '60vh';
    } else if (newLink === '/task/new' && window.innerHeight < 800) {
      scrollerHeight = '51vh';
    }

    return (
      <div id="dataForm" className="list">
        <div className="row m-b-sm p-l-md">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <span className="page-title">
              {totalItems} {title}
            </span>

            <div className="pageStyle">
              {backButton && <BackButton />}

              <button type="button"
                onClick={() => preferTable && switchDisplayStyle()}
                className={preferTable ? 'inactive' : 'active'}>
                <i className="glyphicon glyphicon-th-large" />
                <div className="hover-text">Saraksts</div>
              </button>
              <button type="button"
                onClick={() => !preferTable && switchDisplayStyle()}
                className={preferTable ? 'active' : 'inactive'}>
                <i className="glyphicon glyphicon-th-list" />
                <div className="hover-text">Tabula</div>
              </button>
            </div>

            <div className="sort">
              {tableColumns.filter(column => column.sortable && column.id).map(column => (
                <button type="button"
                  key={`sort${column.id}`}
                  onClick={() => this.handleSortChange(column.id, sortBy === column.id ? !sortDescending : false)}
                  className={`glyphbutton ${sortBy === column.id ? 'active' : ''}`}>
                  <i className={`glyphicon glyphicon-sort-by-attributes${sortBy === column.id && sortDescending ? '-alt' : ''}`} />
                  {column.Header}
                </button>
              ))}
            </div>
          </div>
        </div>
        <hr className="line" />

        {title === 'Lietotāji' && (
          <Item key="list-filter-task-">
            <UserFilter handleFiltersChange={this.handleFiltersChange} />
          </Item>
        )}

        {title === 'Kuponu Izsūtīšanas' && (
          <Item key="list-filter-task-">
            <CouponCampaignFilter handleFiltersChange={this.handleFiltersChange} />
          </Item>
        )}

        <div className="row m-n p-l-md">
          <ListContainer id="scroller" className="m-b-lg"
            style={{ height: scrollerHeight }}>
            <PoseGroup>
              {preferTable ? (
                <Item key="list-data-table">
                  <ReactTable data={tableData}
                    columns={tableColumns}
                    resizable={false}
                    multiSort={false}
                    defaultSorted={[
                      {
                        id: sortBy,
                        desc: sortDescending,
                      },
                    ]}
                    onSortedChange={sort => this.handleSortChange(sort[0].id, sort[0].desc)}
                    pageSize={pageSize}
                    noDataText="Nav ierakstu"
                    minRows={4}
                    showPagination={false} />
                </Item>
              ) : (
                children.map(child => (
                  <Item key={child.key} className="p-t-sm element-item col-xs-12 col-sm-6 col-md-6 col-lg-4">
                    {child}
                  </Item>
                ))
              )}
            </PoseGroup>
          </ListContainer>
          <div id="pager">
            <ReactPaginate nextLabel="»"
              previousLabel="«"
              forcePage={pageIndex}
              pageCount={totalPages}
              marginPagesDisplayed={5}
              pageRangeDisplayed={1}
              onPageChange={this.handlePageChange}
              containerClassName="pagination"
              activeClassName="active" />
          </div>
        </div>
        {newLink && (
          <LinkContainer to={newLink} exact>
            <div className="floating-button">
              <i className="glyphicon glyphicon-plus" />
              <div className="hover-text">Pievienot</div>
            </div>
          </LinkContainer>
        )}
      </div>
    );
  }
}

List.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  title: PropTypes.string.isRequired,
  totalPages: PropTypes.number,
  pageIndex: PropTypes.number,
  pageSize: PropTypes.number,
  totalItems: PropTypes.number,
  sortBy: PropTypes.string,
  sortDescending: PropTypes.bool,
  requestList: PropTypes.func.isRequired,
  tableColumns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  tableData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  newLink: PropTypes.string,
  preferTable: PropTypes.bool.isRequired,
  switchDisplayStyle: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape()),
  backButton: PropTypes.bool,
};

List.defaultProps = {
  totalPages: 0,
  totalItems: 0,
  pageIndex: 0,
  pageSize: 9,
  sortBy: 'name',
  sortDescending: false,
  filters: [],
  newLink: null,
  backButton: false,
};



// WEBPACK FOOTER //
// ./src/containers/List.jsx